module.exports = __webpack_public_path__ + "static/img/2018.740476a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/events/2018.png
// module id = VsI3
// module chunks = 1